import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  RendererStyleFlags2
} from '@angular/core';

// Sets CSS custom properties on the host from a map, for values a stylesheet cannot know in advance
@Directive({
  selector: '[worCssVariables]'
})
export class CssVariablesDirective implements OnChanges {
  @Input() worCssVariables : { [name : string] : string } = {};

  constructor (
    private elementRef : ElementRef<HTMLElement>,
    private renderer   : Renderer2
  ) {}

  ngOnChanges () : void {
    const variables = this.worCssVariables || {};

    Object.keys(variables).forEach(name => {
      if ( variables[name] ) {
        this.renderer.setStyle(this.elementRef.nativeElement, name, variables[name], RendererStyleFlags2.DashCase);
      }
      else {
        this.renderer.removeStyle(this.elementRef.nativeElement, name, RendererStyleFlags2.DashCase);
      }
    });
  }
}
